import React, {
  useState,
  useCallback,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import format from 'string-template';

import useSessionStore from '../../../../../../../../../hooks/useSessionStore';
import useToast from '../../../../../../../../hooks/useToast';
import {
  WeeklyWeightGoal,
  WeeklyWeightGoalText,
} from '../../../../../../../../Model/UserNutritionProfile';
import { InfoLabel } from '../../../../../InfoItem/styles';

import {
  ClientGoalEditIcon,
  ClientGoalWrapper,
  ClientGoalContent,
  ClientGoalSelect,
  ClientGoalMenuItem,
} from './styles';
import texts from './texts.json';

const EMPTY_CELL = '-';

const EditableClientGoal = ({
  userNutritionProfileDoc,
}) => {
  const { userId } = useSessionStore();
  const { showToast } = useToast();
  const [isEditing, setIsEditing] = useState(false);

  const weeklyWeightGoal = userNutritionProfileDoc?.weeklyWeightGoal;

  const clientGoalText = useMemo(() => {
    if (!weeklyWeightGoal) {
      return EMPTY_CELL;
    }
    return WeeklyWeightGoalText[weeklyWeightGoal] || EMPTY_CELL;
  }, [
    weeklyWeightGoal,
  ]);

  const handleGoalChange = useCallback(async (event) => {
    const newGoal = event.target.value;
    setIsEditing(false);
    try {
      await userNutritionProfileDoc.updateFields({
        weeklyWeightGoal: newGoal,
        lastUpdatedBy: userId,
        lastUpdatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
      showToast(texts.clientGoalUpdated);
    } catch (err) {
      showToast(format(texts.clientGoalUpdateFailed, { error: err.message }), { error: true });
    }
  }, [
    userNutritionProfileDoc,
    userId,
    showToast,
  ]);

  return (
    <ClientGoalWrapper>
      <InfoLabel>{texts.clientGoal}</InfoLabel>
      <ClientGoalContent>
        {isEditing ? (
          <ClientGoalSelect
            value={weeklyWeightGoal || ''}
            onChange={handleGoalChange}
            onClose={() => setIsEditing(false)}
            open={isEditing}
            size="small"
          >
            {Object.values(WeeklyWeightGoal).map((goal) => (
              <ClientGoalMenuItem key={goal} value={goal}>
                {WeeklyWeightGoalText[goal]}
              </ClientGoalMenuItem>
            ))}
          </ClientGoalSelect>
        ) : (
          <>
            {clientGoalText}
            {userNutritionProfileDoc && (
              <ClientGoalEditIcon onClick={() => setIsEditing(true)} />
            )}
          </>
        )}
      </ClientGoalContent>
    </ClientGoalWrapper>
  );
};

EditableClientGoal.propTypes = {
  userNutritionProfileDoc: PropTypes.object,
};

EditableClientGoal.defaultProps = {
  userNutritionProfileDoc: null,
};

export default EditableClientGoal;
